import React, {useEffect, useRef, useContext, useCallback, useState} from 'react';
import useKeyPress from '../../../hooks/useKeyPress';
import BodyContentView from '../../views/bodyContentView';
import {useMenu} from '../../../hooks/useMenu';
import ConstantBatchTN from '../constant-batch/constant-batchTN';
import MenuContext from '../../../context/menuContext';
import ConstantBatch from './constant-batch';
import CommandsContext from '../../../context/commandsContext';

function SaveConstant({onExit, initiallyDisableKeypress}) {
  const [isKeypressDisabled, setIsKeypressDisabled] = useState(initiallyDisableKeypress);
  const leftPress = useKeyPress('ArrowLeft');
  const rightPress = useKeyPress('ArrowRight');
  const {selected, onComponent} = useMenu();
  const timeoutRef = useRef();
  const {disableMenu, setDisableMenu} = useContext(MenuContext);
  const {onUpdateCommands} = useContext(CommandsContext);

  const onLeft = useCallback(() => {
    onComponent(<ConstantBatch />);
  }, []);

  const onRight = useCallback(() => {
    onComponent(<ConstantBatchTN />);
  }, []);

  useEffect(() => {
    if (!leftPress) return;

    onLeft();
  }, [leftPress]);

  useEffect(() => {
    if (!rightPress || isKeypressDisabled) return;

    onRight();
  }, [rightPress]);

  useEffect(() => {
    onUpdateCommands({onLeft, onRight});
  }, [onLeft, onRight]);

  useEffect(() => {
    if (!initiallyDisableKeypress) return;

    setTimeout(() => {
      setIsKeypressDisabled(false);
    }, 500);
  }, []);

  return (
    <BodyContentView
      title="Enter Constant Batch Mode"
      left="Cancel"
      right="Continue"
      caption="Set the password required to exit"
    />
  );
}

export default SaveConstant;
